import type { FunctionComponent } from 'react';

import { Drawer } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';

import { breakpoints } from 'styles/theme.variables';

import { useTranslation } from 'i18n';
import { CreateCampaignForm } from './CreateCampaignForm';

const NS = 'autoCampaignSettings';

export type CreateCampaignDrawerProps = {
  onClose: () => void;
  opened: boolean;
};

export const CreateCampaignDrawer: FunctionComponent<CreateCampaignDrawerProps> = ({
  onClose,
  opened,
}) => {
  const { t } = useTranslation(NS);
  const isMobile = useMediaQuery(`(max-width: ${breakpoints.maxMobile})`);

  return (
    <Drawer
      opened={opened}
      onClose={onClose}
      title={t('CreateCampaignDrawer.title')}
      variant="withDock"
      size={isMobile ? 'sm' : 'lg'}
    >
      {/* Remounts per open so a half-filled form does not come back. */}
      {opened && <CreateCampaignForm onClose={onClose} />}
    </Drawer>
  );
};
